const navToggle  = document.getElementById('nav-toggle');
const nav        = document.getElementById('nav');
const body       = document.body;

let isMenuOpen = false;

// TODO: collections menu — wire up when gallery/collections page is built
// let isCollectionsMenuOpen = false;

if (navToggle && nav) {
    navToggle.addEventListener('click', function (e) {
        e.preventDefault();

        if (!isMenuOpen) {
            openMainMenu();
        } else {
            closeMainMenu();
        }
    });
}

function openMainMenu() {
    syncSubnavActiveState();
    nav.classList.remove('hidden');

    setTimeout(() => {
        body.classList.add('menu-animate');
    }, 10);

    body.style.overflow = 'hidden';
    navToggle.setAttribute('aria-expanded', 'true');
    nav.setAttribute('aria-hidden', 'false');
    isMenuOpen = true;
}

// The primary nav lives outside #swup, so PHP cannot refresh its active state
// after a soft navigation. Match only the Collections/Accessories subnav URLs;
// the top-level disclosure labels deliberately keep their existing styling.
function syncSubnavActiveState() {
    const current = new URL(window.location.href);
    const currentPath = current.pathname.replace(/\/$/, '');
    const currentFilter = (current.searchParams.get('filter') || '').toLowerCase();

    document.querySelectorAll('#main-menu .primary-subnav-link[href]').forEach(link => {
        const target = new URL(link.href, current);
        const targetPath = target.pathname.replace(/\/$/, '');
        const targetFilter = (target.searchParams.get('filter') || '').toLowerCase();
        const isCurrent = target.origin === current.origin
            && targetPath === currentPath
            && targetFilter === currentFilter;

        link.classList.toggle('is-current', isCurrent);
        if (isCurrent) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
    });
}

syncSubnavActiveState();
window.addEventListener('popstate', syncSubnavActiveState);

function closeMainMenu() {
    body.classList.remove('menu-animate');

    setTimeout(() => {
        nav.classList.add('hidden');
        body.style.overflow = '';
        navToggle.setAttribute('aria-expanded', 'false');
        nav.setAttribute('aria-hidden', 'true');
        isMenuOpen = false;
        // Collapse any open submenu now that the menu is hidden — invisible to
        // the user, so it doesn't snap shut before the close animation.
        document.querySelectorAll('#main-menu details[open]').forEach(d => d.removeAttribute('open'));
    }, 300);
}

// Close on Escape
document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isMenuOpen) {
        closeMainMenu();
    }
});


export { isMenuOpen, closeMainMenu, syncSubnavActiveState };
